<app-sidebar [menuItems]="menuItems">
  <router-outlet></router-outlet>
</app-sidebar>
